import script from "./SelectSurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectSurvey.vue?vue&type=script&setup=true&lang=js"

import "./SelectSurvey.vue?vue&type=style&index=0&id=b4b1786e&lang=css"

const __exports__ = script;

export default __exports__